import api from "../services/api";

export const fetchAiPhoneSettings = () => api.get("/api/ai-chatbot/phones");

export const toggleAiForPhone = (phoneId, enabled) =>
  api.put(`/api/ai-chatbot/phones/${phoneId}/toggle`, { ai_enabled: enabled ? 1 : 0 });

export const updateAiKnowledgeBase = (phoneId, knowledgeBase) =>
  api.put(`/api/ai-chatbot/phones/${phoneId}/knowledge-base`, {
    knowledge_base: knowledgeBase,
  });

export const updateAiChatbotSettings = (phoneId, settings) =>
  api.put(`/api/ai-chatbot/phones/${phoneId}/settings`, settings);

export const scrapeWebsite = (url) =>
  api.post("/api/ai-chatbot/scrape-website", { url });


